import type * as React from "react";

/**
 * Loading placeholder shaped like the content it replaces. Not part of the Wanted kit; built
 * from its fill-normal token and radius scale (pulse is off under reduced motion).
 */
export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: string;
  style?: React.CSSProperties;
  className?: string;
}

export function Skeleton({ width = "100%", height = 16, radius, style, className }: SkeletonProps) {
  return (
    <span
      aria-hidden
      className={["tv-skeleton", className].filter(Boolean).join(" ")}
      style={{ display: "block", width, height, borderRadius: radius, ...style }}
    />
  );
}

export default Skeleton;
